import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { gql } from '@/__generated__/index.ts';

const AddUsersToStream = gql(`
  mutation AddUsersToStream($streamId: ID!, $userIds: [ID!]!) {
    addUsersToStream(streamId: $streamId, userIds: $userIds) {
      id
    }
  }
`);

export const useAddUsersToStream = (streamId: string) => {
  const toast = useToast();

  const [addUsersToStreamMutation, result] = useMutation(AddUsersToStream, {
    onError: () => {
      toast.error({
        title: 'Failed to add users',
        subTitle: 'Please try again',
      });
    },
    onCompleted: () => {
      toast.info({
        title: 'Users successfully added',
      });
    },
  });

  const addUsersToStream = (userIds: string[]) => {
    return addUsersToStreamMutation({
      variables: {
        userIds,
        streamId,
      },
    });
  };

  return [addUsersToStream, result] as const;
};
